import { Theme, ThemeOptions } from '@mui/material'

export const createPalette = (theme: Theme): ThemeOptions['palette'] => {
  const augment = (main: string, name: string) =>
    theme.palette.augmentColor({ color: { main }, name })

  return {
    background: { default: theme.palette.grey[100] },
    black: augment('#222222', 'black'),
    contrastThreshold: 4.5, // https://mui.com/material-ui/customization/palette/#accessibility
    cream: augment('#FAF3DE', 'cream'),
    error: augment('#F33308', 'error'),
    info: augment('#1681FF', 'info'),
    movement: augment('#3E71FF', 'movement'), // blue
    primary: augment('#222222', 'primary'), // black
    purple: augment('#701ED9', 'purple'),
    secondary: augment('#FF234F', 'secondary'), // Yieldbird
    success: augment('#22C55E', 'success'),
    warning: augment('#FFAB00', 'warning'),
    white: augment(theme.palette.common.white, 'white'),
  }
}
